import React from 'react';
import PropTypes from 'prop-types';

import styles from './CenterImage.css';

const CenterImage = ({ image }) => (
  <div className={styles.centerImage}>{image}</div>
);

CenterImage.propTypes = {
  image: PropTypes.node.isRequired,
};

export default CenterImage;
